import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';

const CommonRadioGroup = ({
  label,
  name,
  value,
  options = [],
  onChange,
  row = false,
  gap = 1.5,
  type,
}) => {
  console.log(options, 'res');
  return (
    <FormControl
      sx={{
        width: type === 'postcode' ? '100%' : undefined,
        '& .MuiFormControlLabel-label': {
          fontFamily: 'outfit_regular',
        },
        '& .MuiFormLabel-root': {
          fontFamily: 'outfit_regular',
        },
      }}
    >
      {label && <FormLabel sx={{ color: '#7b7b7b' }}>{label}</FormLabel>}
      <RadioGroup
        row={row}
        name={name}
        value={value}
        onChange={onChange}
        sx={{
          gap: row ? gap : undefined,
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio
                sx={{
                  color: '#7b7b7b',
                  '&.Mui-checked': {
                    color: '#864629',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: 25,
                  },
                }}
              />
            }
            label={option.label}
            sx={{
              color: 'black',
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CommonRadioGroup;
